/**
 * @public
 */
export const DEFAULT_AVATAR_IMG = '/img/hozana_img_avatar_default.png'

/**
 * @public
 */
export enum GENDER {
  M = 'm',
  F = 'f',
}

/**
 * @public
 */
export enum USER_TITLE {
  MISS = 'miss',
  MRS = 'mrs',
  MR = 'mr',
  FAMILY = 'family',
  FATHER = 'father',
  SISTER = 'sister',
  BROTHER = 'brother',
  ORG = 'org',
  DEACON = 'deacon',
}
